import { Container, ContainerModule, inject, injectable, decorate, unmanaged } from 'inversify'

const loadModules = (
    container: Container,
    module: ContainerModule | Array<ContainerModule>
) => {
    if (!Array.isArray(module)) {
        module = [module]
    }

    module.forEach(module => container.loadSync(module))
}


export {
    Container,
    ContainerModule,
    inject,
    injectable,
    decorate,
    unmanaged,
    loadModules
}
